import React from 'react';

import { withAuthenticationRequired } from '@auth0/auth0-react';

import { EvSpinner } from '@evinced-private/ui-common';

import { getEmailFromUrl } from '../../helpers/InvitationTokenHelper';

import { AuthToken } from './AuthToken';

const userEmail = getEmailFromUrl();

export const SignupPage = withAuthenticationRequired(AuthToken, {
	onRedirecting: () => {
		return <EvSpinner />;
	},
	loginOptions: {
		authorizationParams: {
			screen_hint: 'signup',
			...(userEmail ? { login_hint: userEmail } : {})
		}
	}
});
